import React from 'react';

const BackSocketContext = React.createContext();

export default BackSocketContext;
